import moment from "moment";
import { outputmoney } from "./number";

const auditStatus = [
  {
    value: 0,
    label: "待审核",
  },
  {
    value: 1,
    label: "已批准",
  },
  {
    value: 2,
    label: "已驳回",
  },
];

const formatDateTime = (value, value2) => {
  if (value) {
    return moment(value).format("YYYY-MM-DD HH:mm:ss");
  } else {
    return moment(value2).format("YYYY-MM-DD HH:mm:ss");
  }
};

const filterPrice = (val) => {
  if (val == 0) {
    return "0.00";
  }
  if (val) {
    return outputmoney(val.toString());
  }
};

const filterAudit = (value) => {
  return auditStatus[value]?.label || "";
};

export { formatDateTime, filterPrice, filterAudit };
